const picList = [
  require('@/assets/images/新能源产业专利动态图片.png'),
  require('@/assets/images/绿色石化产业专利动态图片.png'),
]
const fields = [
  {
    dataIndex: 'key',
    key: 'key',
    title: '排名',
    width: 80
  },
  {
    dataIndex: 'name',
    key: 'name',
    title: '申请人'
  },
  {
    dataIndex: 'value',
    key: 'value',
    width: 100,
    title: '数量'
  }
]

module.exports = {
  picList,
  fields
}
